import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  BalanceOfContractLeadStageTwoPopupComponent,
  LeadCreationEffects,
  NoSalesPopUpComponent,
  PartitionPopupComponent,
  QuotationPendingPopUpComponent,
  QuoteDeclinePopUpComponent,
  ServicePopupComponent,
  TaskManagementRoutingModule, TaskMgmtPartitionNameModalComponent,
  leadCreationStepperParamsReducer, leadCreationUserDataReducer, leadHeaderDataReducer
} from '@sales/components/task-management';
import { GaugeChartModule } from 'angular-gauge-chart';
import { RatingModule } from 'primeng/rating';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SalesModule } from '../../sales.module';
import { LeadLifecycleReusableComponentsModule } from '../lead-header/lead-lifecycle-reusable-components.module';
import { UpdateStockModalComponent } from '../lead-notes';
import { AppointmentEscalationPopupComponent } from '../lead-notes/appointment-escalation/appointment-escalation-pop-up.component';
import { AppointmentHistoryComponent } from '../lead-notes/appointment-history.component';
import { ScheduleCallbackViewModalModule } from '../lead-notes/schedule-callback-view-modal.module';
import { taskManagementComponentsDeclarations } from './';
import { NewAddressModule } from './lead-info/new-address/new-address.module';
import { KeyValuePipe } from '@angular/common';
import { MultipleQuotationAcceptDialogComponent } from './latest-lead-stage-flows/quotation-view/multiple-quotation-accept-dialog/multiple-quotation-accept-dialog.component';

const entryComponents = [TaskMgmtPartitionNameModalComponent, ServicePopupComponent, MultipleQuotationAcceptDialogComponent,
  PartitionPopupComponent, AppointmentHistoryComponent, QuotationPendingPopUpComponent,
  NoSalesPopUpComponent, QuoteDeclinePopUpComponent, BalanceOfContractLeadStageTwoPopupComponent, AppointmentEscalationPopupComponent, UpdateStockModalComponent];
@NgModule({
  declarations: [...taskManagementComponentsDeclarations, ...entryComponents],
  imports: [
    ScheduleCallbackViewModalModule,
    SharedModule, TaskManagementRoutingModule,
    MaterialModule, RatingModule, ScrollPanelModule,
    StoreModule.forFeature('leadCreationUserData', leadCreationUserDataReducer),
    StoreModule.forFeature('leadCreationStepperParams', leadCreationStepperParamsReducer),
    StoreModule.forFeature('leadHeaderData', leadHeaderDataReducer),
    EffectsModule.forFeature([LeadCreationEffects]),
    GaugeChartModule, SalesModule, NewAddressModule,
    LeadLifecycleReusableComponentsModule
  ],
  entryComponents,
  providers: [KeyValuePipe]
})
export class TaskManagementModule { }
